import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { findCourses } from './infra/repository/FindCourses';
import './style/courses.scss';

export default function Courses() {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let active = true;
    findCourses().then(
      courses => { if (active) setState({ courses, loading: false }); },
      () => { if (active) setState({ loading: false, error: 'Unable to load courses. Please try again.' }); }
    );
    return () => { active = false; };
  }, []);

  return (
    <main className="courses">
      <h1>Courses</h1>
      {state.loading && <p><output>Loading courses…</output></p>}
      {state.error && <p role="alert">{state.error}</p>}
      {state.courses?.length === 0 && <p>No courses available yet.</p>}
      {state.courses?.length > 0 && <ul className="courses__list">
        {state.courses.map(course => (
          <li className="courses__item" key={course.id}>
            <Link to={`/course/${encodeURIComponent(course.id)}`}>{course.title}</Link>
          </li>
        ))}
      </ul>}
    </main>
  );
}
